<template>
  <section>
    <header class="header-area">
      <div class="navbar-area">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <nav class="navbar navbar-expand-lg">
                <a class="navbar-brand" href="/home">
                  <img
                    style="height: 100%; width: 100%"
                    src="/images/logo.webp"
                    alt="Logo"
                  />
                </a>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="toggler-icon"></span>
                  <span class="toggler-icon"></span>
                  <span class="toggler-icon"></span>
                </button>

                <div
                  class="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul id="nav" class="navbar-nav ml-auto">
                    <li id="homepage" class="nav-item active">
                      <a class="page-scroll title-mobile" href="/home">{{
                        $t("home")
                      }}</a>
                    </li>
                    <li id="document" class="nav-item">
                      <a class="page-scroll title-mobile" href="/document">{{
                        $t("document")
                      }}</a>
                    </li>
                    <li id="showcase" class="nav-item">
                      <a class="page-scroll title-mobile" href="/showcase">{{
                        $t("showcase")
                      }}</a>
                    </li>
                    <li id="tech-specs" class="nav-item">
                      <a class="page-scroll title-mobile" href="/tech-specs">{{
                        $t("tech_specs")
                      }}</a>
                    </li>
                    <li id="tech-specs" class="nav-item">
                      <a
                        class="page-scroll title-mobile"
                        target="_blank"
                        href="https://ai-visualization.vieon.vn/"
                        >{{ $t("AI Visualization") }}</a
                      >
                    </li>
                  </ul>
                </div>
                <!-- navbar collapse -->
              </nav>
              <!-- navbar -->
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- container -->
      </div>
      <!-- navbar area -->

      <div
        id="home"
        class="header-hero bg_cover"
        style="background-image: url(/images/banner-bg.svg)"
      >
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="header-hero-content text-center">
                <h3
                  class="header-sub-title wow fadeInUp"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.2s"
                >
                  AI Indexing
                </h3>
                <p
                  class="text wow fadeInUp"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.8s"
                >
                  {{ $t("des_app") }}
                </p>
              </div>

              <!-- header hero content -->
            </div>
          </div>
          <div class="wow fadeInUp row no-gutters justify-content-center">
            <v-dialog v-model="dialog" :width="widthDialog">
              <template v-slot:activator="{ on, attrs }">
                <a
                  v-bind="attrs"
                  v-on="on"
                  class="main-btn"
                  style="border: 1px white solid"
                >
                  <v-icon large left class="mr-6" color="white">{{
                    rightDropCircle
                  }}</v-icon>
                  {{ $t("watch_video") }}
                </a>
              </template>
              <v-card style="position: relative">
                <video
                  autoplay
                  muted
                  playsinline
                  controls
                  @ended="dialog = false"
                  src="https://static2.vieon.vn/ai-storage/ImagePublic/ai_indexing.mp4"
                ></video>
                <v-icon
                  large
                  dark
                  style="
                    position: absolute;
                    top: 4px;
                    right: 4px;
                    cursor: pointer;
                  "
                  @click="dialog = false"
                  >{{ iconClose }}</v-icon
                >
              </v-card>
            </v-dialog>
          </div>
        </div>
        <!-- container -->
        <div id="particles-1" class="particles"></div>
      </div>
      <!-- header hero -->
    </header>
    <transition name="fade" mode="out-in">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
      <router-view v-else></router-view>
    </transition>
    <footer id="footer" class="footer-area pt-150">
      <div class="container-fluid">
        <!-- subscribe area -->
        <div class="footer-widget px-12">
          <div class="row justify-start">
            <div class="col-10">
              <div
                class="footer-about wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                <a class="logo" href="/home">
                  <img
                    style="height: 75%; width: 75%"
                    src="/images/logo-foot.webp"
                    alt="logo"
                  />
                </a>
                <p class="text">
                  {{ $t("footer_des") }}
                </p>
                <ul class="social">
                  <li>
                    <a href="#"><i class="lni-facebook-filled"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni-twitter-filled"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni-instagram-filled"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni-linkedin-original"></i></a>
                  </li>
                </ul>
              </div>
              <!-- footer about -->
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- footer widget -->
      </div>
      <!-- container -->
      <div id="particles-2"></div>
    </footer>
    <!--====== BACK TOP TOP PART START ======-->
    <div class="back-to-top">
      <v-icon color="white">{{ doubleUp }}</v-icon>
    </div>
  </section>
</template>

<script>
import i18n from "../i18n";
import { mdiArrowRightDropCircle, mdiClose, mdiChevronDoubleUp } from "@mdi/js";
export default {
  name: "BaseLayout",
  created() {
    const locale = localStorage.getItem("lang");
    if (locale) {
      this.locale = locale;
      i18n.locale = locale;
    }
  },
  data() {
    return {
      locale: "en",
      reloadFlag: 1,
      dialog: false,
      rightDropCircle: mdiArrowRightDropCircle,
      iconClose: mdiClose,
      doubleUp: mdiChevronDoubleUp,
    };
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
      this.locale = locale;
      this.reloadFlag += 1;
      localStorage.setItem("lang", locale);
    },
  },
  computed: {
    widthDialog() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100vw";
        case "sm":
          return "100vw";
        case "md":
          return "100vw";
        case "lg":
          return "50vw";
        case "xl":
          return "50vw";
        default:
          return "100vw";
      }
    },
  },
};
</script>

<style>
@import "../../public/css/bootstrap.min.css";

.container {
  width: 100% !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
  margin-right: auto !important;
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
.header-area {
  margin-bottom: 20px;
}
</style>
